'use client';
import type { PromotionResponseDetails } from '@/types';

import {
  Box,
  Container,
  Divider,
  ProductCard,
  SimpleGrid,
  Text,
} from '@/components';
import { routes } from '@/statics';

const MainContent: React.FC<{ promotionData: PromotionResponseDetails[] }> = ({
  promotionData,
}) => {
  return (
    <Container marginBottom="50px" backgroundColor="white">
      {promotionData.map((category) => {
        return (
          <>
            <Box key={category.code} marginTop={{ base: '19px', md: '40px' }}>
              <Text fontWeight={700} fontSize={{ base: 'md', md: 'lg' }}>
                {category.title}
              </Text>
              <SimpleGrid
                columns={{ base: 2, lg: 3, xl: 4, '2xl': 5 }}
                marginTop="20px"
                gap={4}
              >
                {category.products.map((product) => {
                  return (
                    <ProductCard
                      key={product.id}
                      cardData={product.product_group}
                      link={routes.product.href(product.product_group.code)}
                    />
                  );
                })}
              </SimpleGrid>
            </Box>
            <Divider marginTop={{ base: 8, md: 12 }} />
          </>
        );
      })}
    </Container>
  );
};
export default MainContent;
